import { FC, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Select, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { CommerceNoticeStatusCode } from '@gooduncles/gu-app-schema';

import { commerceNoticeStatusLabel } from 'src/constants/commerce-notice.constants';
import { useCommerceNotices } from 'src/hooks/useCommerceNotice';
import { WHERE } from 'src/utils/firebase/firebase-manager';

import CommerceNoticeTable from 'src/components/CommerceNotice/CommerceNoticeTable/CommerceNoticeTable';

const statusOptions = [
  { label: '전체', value: 'all' },
  ...Object.entries(commerceNoticeStatusLabel).map(([value, label]) => ({
    label,
    value: Number(value),
  })),
];

const CommerceNoticeListPage: FC = () => {
  const navigate = useNavigate();
  const [statusFilter, setStatusFilter] = useState<CommerceNoticeStatusCode | 'all'>('all');

  const wheres: WHERE[] | undefined = useMemo(
    () => (statusFilter === 'all' ? undefined : [['status', '==', statusFilter]]),
    [statusFilter],
  );

  const { notices } = useCommerceNotices(wheres);

  return (
    <div style={{ padding: 24 }}>
      <Space style={{ marginBottom: 16, width: '100%', justifyContent: 'space-between' }}>
        <Select
          value={statusFilter}
          onChange={setStatusFilter}
          options={statusOptions}
          style={{ width: 160 }}
          placeholder='상태 필터'
        />
        <Button type='primary' icon={<PlusOutlined />} onClick={() => navigate('/commerce-notice/create')}>
          공지사항 작성
        </Button>
      </Space>
      <CommerceNoticeTable notices={notices} />
    </div>
  );
};

export default CommerceNoticeListPage;
